module.exports = __webpack_public_path__ + "static/img/device_empt.82fe2cc7.png";